import React, { Component, useState, useEffect } from 'react';
import {
    Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink,
    UncontrolledDropdown,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import './NavMenu.css';

import useAuthUser from 'react-auth-kit/hooks/useAuthUser';
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

import { faUser  } from '@fortawesome/free-regular-svg-icons';
import { faUser as faUserSolid } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import axios from 'axios';
import { useApiFetch } from '../ApiFetch';

export const NavMenu = () => {
    const signOut = useSignOut();
    const authUser = useAuthUser();
    //const authHeader = useAuthHeader();
    //const isAuthenticated = useIsAuthenticated();
    const navigate = useNavigate();
    //const apiFetch = useApiFetch();
    

    const [collapsed, setCollapsed] = useState(true);

    const toggleNavbar = () => {
        setCollapsed(!collapsed)
    }
    //const handleLogin = () => {
    //    //instance.loginRedirect(loginRequest);
    //}
    const handleLogout = (e) => {
        e.preventDefault();
        signOut()
        navigate('/');
    };

   
    return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3" container>
                    <NavbarBrand tag={Link} to="/">
                    <span className="bg-dark px-2 py-2 border border-dark rounded">
                    <img className="pb-1" src="https://www.sidekick.events/assets/images/sidekick_logo_right.png" alt="Sidekick" height="34" />
                    </span>
                    {"\u00A0"} Sidekick Listings
                    </NavbarBrand>
                    <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                    {/*<ul className="navbar-nav flex-grow">*/}
                        <Nav navbar>
                            <NavItem>
                                <NavLink tag={Link} to="/">Home</NavLink>
                        </NavItem>
                        {/*{isAuthenticated ?
                           <>
                                <NavItem>
                                    <NavLink tag={Link} to="/tournament">Tournament Registration</NavLink>
                                </NavItem>
                            </>
                            : null } */}
                        <UncontrolledDropdown nav>
                            <DropdownToggle nav caret>
                                {authUser ?
                                    <>
                                        <FontAwesomeIcon icon={faUserSolid} />
                                    </>
                                    :
                                    <>
                                        <FontAwesomeIcon icon={faUser} />
                                    </>
                                }
                            </DropdownToggle>
                            <DropdownMenu flip tag="ul">
                                {authUser ?
                                    <>
                                        <DropdownItem text tag="li">Welcome{authUser.profile && authUser.profile.firstName ? ', ' + authUser.profile.firstName : '!' }</DropdownItem>
                                        <DropdownItem divider tag="li" />
                                        <DropdownItem tag="li" onClick={handleLogout}>Log Out</DropdownItem>
                                    </>
                                    :
                                    <>
                                        <DropdownItem tag={Link} to="/profile/register" >Register</DropdownItem>
                                        <DropdownItem divider tag="li" />
                                        <DropdownItem tag={Link} to="/login" >Log In</DropdownItem>
                                    </>
                                }
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </Nav>
                    </Collapse>
                </Navbar>
            </header>
        );
}
